import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';

export default function SummaryBox(props) {
  const {
    caption,
    value,
    unit,
    type,
    children,
    ...rest
  } = props;
  return (
    <VBox {...ex('SummaryBox', rest)}>
      <HBox>
        {children && (
          <div>
            {children}
          </div>
        )}
        <div>
          {caption}
        </div>
      </HBox>
      <HBox>
        <div {...ex(type)}>
          {!(value instanceof Array) && value}
          {value instanceof Array && value.map((text) => !!text && (
            <div
              key={text}
              {...ex('SummaryTag')}
            >
              {text}
            </div>
          ))}
        </div>
        <div>
          {unit}
        </div>
      </HBox>
    </VBox>
  );
}
